export default __webpack_public_path__ + "static/media/admin-cursos.edde387f.svg";